// extracted by mini-css-extract-plugin
export var table = "_wv-0";